import { Axios } from "@lib";
import type {
	ChecklistAnswerInitializeParams,
	ChecklistAnswerResponse,
} from "../types";

export async function summaryAnswerInitialize(
	payload: ChecklistAnswerInitializeParams
) {
	const { answerId, body } = payload;

	const { data } = await Axios.put<ChecklistAnswerResponse>(
		`/api/checklist/answer/${answerId}/initialize`,
		body
	);

	return data;
}
